<!-- 
import { Component } from "@angular/core";

@Component({
    selector: "form-field-storybook",
    templateUrl: "./form-field-storybook.component.html",
})
export class FormFieldStorybookComponent {
    formFieldTypes = ["input", "textarea", "select"] as const;
    formFieldSizes = ["small", "medium", "large"] as const;
}
 
-->

<div class="grid grid-cols-3 gap-4">
    <ng-container *ngFor="let size of formFieldSizes">
        <ng-container *ngFor="let type of formFieldTypes; let i = index">

            <!-- switch type for building mat-form-fields -->
            <ng-container [ngSwitch]="type">
                <mat-form-field class="v2-form-field" *ngSwitchCase="'input'" [class]="size">
                    <mat-label>Input</mat-label>
                    <input matInput placeholder="Placeholder">
                </mat-form-field>

                <mat-form-field class="v2-form-field" *ngSwitchCase="'textarea'">
                    <mat-label>Textarea</mat-label>
                    <textarea matInput placeholder="Placeholder"></textarea>
                </mat-form-field>

                <mat-form-field class="v2-form-field" *ngSwitchCase="'select'" [class]="size">
                    <mat-label>Select</mat-label>
                    <mat-select>
                        <mat-option value="option1">Option 1</mat-option>
                        <mat-option value="option2">Option 2</mat-option>
                    </mat-select>
                </mat-form-field>
            </ng-container>

        </ng-container>
    </ng-container>

    <mat-form-field class="v2-form-field medium">
        <mat-label>Required Input for error testing</mat-label>
        <input [formControl]="requiredControl" matInput placeholder="Placeholder" required>
        <mat-error>Todo input com erro deve ter um helper text</mat-error>
    </mat-form-field>

    <mat-form-field class="v2-form-field medium" disabled>
        <mat-label>Disabled Input</mat-label>
        <input matInput placeholder="Placeholder" disabled>
    </mat-form-field>
</div>